import { render, staticRenderFns } from "./PredictivePaywallHistory.vue?vue&type=template&id=20f7798b&scoped=true"
import script from "./PredictivePaywallHistory.vue?vue&type=script&lang=js"
export * from "./PredictivePaywallHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7798b",
  null
  
)

export default component.exports